import React, { Component } from 'react'
import { Button, Typography, message, Modal, Checkbox } from 'antd';

import FeeInstallModel from 'feeInstall'
import extHandlers from './extHandlers'

import styles from './style.scss?__local';

import request from 'request'

const { Title, Paragraph, Text } = Typography;

class FeeInstallModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isChecked: false,
      visible: true,
      hyBeanNum: 0,
      loading: false,
    }

    this.install = this.install.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOk = this.handleOk.bind(this);
    this.switchCheckbox = this.switchCheckbox.bind(this);

    this.feeInstallModelInstance = null;
  }

  componentDidMount() {
    this.getUserHuyaCoinBalance();
  }

  componentWillUnmount() {
    if (this.feeInstallModelInstance) {
      this.feeInstallModelInstance.removeAllListeners();
      this.feeInstallModelInstance.destory();
    }
  }

  install() {
    const { data: {extUuid}, hasBuy } = this.props;

    this.feeInstallModelInstance = new FeeInstallModel({hasBuy, extUuid});

    this.feeInstallModelInstance.on('error', err => {
      message.warn(err);

      this.setState({
        loading: false,
      })
    })

    this.feeInstallModelInstance.on('start', () => {
      this.setState({
        loading: true,
      })
    })

    this.feeInstallModelInstance.on('success', () => {
      this.setState({
        loading: false,
      })

      this.props.setHasInstall();
      // 关闭弹窗
    })
  }

  getOkBtn() {
    const { loading } = this.state;

    if (loading) {
      return '支付中, 请稍后';
    }

    return '开通';
  }

  switchCheckbox() {
    const { isChecked } = this.state;

    this.setState({
      isChecked: !isChecked,
    })
  }

  getUserHuyaCoinBalance() {
    request({
      type: 'GET',
      url: request.api.getHuyaCoinBalance,
    })
      .done(res => {
        this.setState({
          hyBeanNum: res,
        })
      })
      .fail(err => {

      })
  }

  handleOk() {
    const { isChecked } = this.state;
    if (!isChecked) {
      message.warn('请勾选协议');
      return;
    }

    this.install();
  }

  handleCancel() {
    // 通知父组件 关闭弹窗

    this.props.closeModal();
  }

  /*
    * @serviceFee.type {Number} 1, 使用时长; 2, 礼物流水;
    */
  getFeeDetailDesc(hasService, installationFee, serviceFee) {
    let desc = '';

    if (installationFee) {
      desc += '首次安装将收取安装费，后续版本升级将不收取安装费用；';
    }

    if (hasService) {
      if (serviceFee.type === 1) {
        desc += '将根据使用该小程序的时长收取梯度服务费，当月服务费等于当月该小程序使用时长对应的服务费，服务费将在次月月初结算，首次同意后次日生效。';
      }

      if (serviceFee.type === 2) {
        desc += '将根据该小程序中产生的礼物流水收取梯度服务费，当月服务费等于当月该小程序产生的礼物流水*对应区间费率，最高不超过封顶费用。服务费将在次月月初结算，首次同意后下场使用生效。';
      }
    }

    return desc;
  }

  render() {
    const { isChecked, hyBeanNum, loading, visible } = this.state;
    const { hasBuy, data, hasService } = this.props;

    const { installationFee, serviceFee } = data;

    function handle(key) {
      const value = data[key]
      return handlers[key] ? handlers[key](value) : value
    }

    const handlers = extHandlers(data);

    return (
      <div>
        <Modal
          title="费用收取详情"
          visible={visible}
          centered = {true}
          width={480}
          mask = {true}
          onCancel={this.handleCancel}
          footer={[
            <Button key="back" onClick={this.handleCancel}>
                          拒绝
            </Button>,
            <Button key="submit" type="primary" loading={loading} onClick={this.handleOk} disabled = {!isChecked}>
              {this.getOkBtn()}
            </Button>,
          ]}
        >
          <div style={{overflow: 'auto'}}>
            <div className={styles.confirm_media}>

              <img src={ handle('extLogo') } className={styles.logo}/>

              <div className={styles.main}>
                <Title level = {4}>{ handle('extName')}</Title>
                <p className={styles.title}>功能介绍：</p>

                <div className={styles.desc}>
                  { handle('extDescription') || '暂无' }
                </div>

              </div>
            </div>

            <div className = {styles.confirm_desc}>
              <Title level = {4}>收取费用详情</Title>
              <p>{this.getFeeDetailDesc(hasService, installationFee, serviceFee)}</p>
            </div>

            {
              installationFee ?
                <div>
                  <Title level = {4}>安装费详情</Title>
                  <p>{installationFee / 100}虎牙币</p>
                </div>
                :
                null
            }

            {
              hasService ?
                <div className={styles.confirm_service}>
                  <Title level = {4}>服务费详情</Title>
                  <div>
                    { handle('serviceFee') }
                  </div>
                </div>
                :
                null
            }

            <p className={styles.confirm_bean}>支付方式：虎牙币支付（剩余{hyBeanNum}）<a href="https://zhifu.huya.com/web/pay_hy_coin.html" target="_blank">立即充值</a></p>
          </div>

          <div>
            <Checkbox onChange = {this.switchCheckbox}>我已阅读并会遵守<a href="https://cmsstatic.huya.com/huya_xiaochengxu/service.html"> 主播服务协议 </a></Checkbox>
          </div>
        </Modal>
      </div>
    )
  }
}

export default FeeInstallModal;